import CustomilyCalendar from '@customily/customily-calendar';

const generateCustomilyCalendar = async function (object, date = new Date()) {
    try {
        const targetCustomilyCalendar = new CustomilyCalendar(object.calendarConfig);

        const output = await targetCustomilyCalendar.export({
            date,
            width: 2000,
            height: 2000
        });

        if (!output) {
            throw new Error('generateCalendar did not return a valid Node.');
        }

        return output;
    } catch (error) {
        console.error('generateCustomilyCalendar', error);
    }
};

export { generateCustomilyCalendar };
